import { render, staticRenderFns } from "./App2020.vue?vue&type=template&id=84e6df92&scoped=true&"
import script from "./App2020.vue?vue&type=script&lang=js&"
export * from "./App2020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e6df92",
  null
  
)

export default component.exports